import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'valImageLoaded' })
export class ValImageLoadedPipe implements PipeTransform {
    transform(model: Array<any>, trigger = 0): boolean {
        if (!model) { return true; }
        return model.filter(x => !x.isLoaded).length === 0;
    }
}
